import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/api/query-keys";
import { getMe } from "../api/getMe";

/**
 * The current user, for plan-gating inside chat (web search is paid-plan only).
 * Shares the `me.detail()` query key with the auth feature, so this rides the
 * same TanStack Query cache entry — no extra network request.
 */
export function useMe() {
  return useQuery({
    queryKey: queryKeys.me.detail(),
    queryFn: getMe,
    staleTime: 5 * 60_000,
  });
}
